'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var BufferList = require('bl/BufferList');

var _require = require('libp2p-interfaces/src/crypto/errors'),
    InvalidCryptoTransmissionError = _require.InvalidCryptoTransmissionError;

exports.createBoxStream = function (cipher, mac) {
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, data, digest;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context.next = 6;
              return _awaitAsyncGenerator(_iterator.next());

            case 6:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 10;
              return _awaitAsyncGenerator(_step.value);

            case 10:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 24;
                break;
              }

              chunk = _value;
              _context.next = 15;
              return _awaitAsyncGenerator(cipher.encrypt(BufferList.isBufferList(chunk) ? chunk.slice() : chunk));

            case 15:
              data = _context.sent;
              _context.next = 18;
              return _awaitAsyncGenerator(mac.digest(data));

            case 18:
              digest = _context.sent;
              _context.next = 21;
              return new BufferList([data, digest]);

            case 21:
              _iteratorNormalCompletion = true;
              _context.next = 4;
              break;

            case 24:
              _context.next = 30;
              break;

            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 30:
              _context.prev = 30;
              _context.prev = 31;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 35;
                break;
              }

              _context.next = 35;
              return _awaitAsyncGenerator(_iterator.return());

            case 35:
              _context.prev = 35;

              if (!_didIteratorError) {
                _context.next = 38;
                break;
              }

              throw _iteratorError;

            case 38:
              return _context.finish(35);

            case 39:
              return _context.finish(30);

            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 26, 30, 40], [31,, 35, 39]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.createUnboxStream = function (decipher, mac) {
  return /*#__PURE__*/function () {
    var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, chunk, l, macSize, mark, data, macd, expected, decrypted;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context2.prev = 2;
              _iterator2 = _asyncIterator(source);

            case 4:
              _context2.next = 6;
              return _awaitAsyncGenerator(_iterator2.next());

            case 6:
              _step2 = _context2.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context2.next = 10;
              return _awaitAsyncGenerator(_step2.value);

            case 10:
              _value2 = _context2.sent;

              if (_iteratorNormalCompletion2) {
                _context2.next = 33;
                break;
              }

              chunk = _value2;
              l = chunk.length;
              macSize = mac.length;

              if (!(l < macSize)) {
                _context2.next = 17;
                break;
              }

              throw new InvalidCryptoTransmissionError("buffer (".concat(l, ") shorter than MAC size (").concat(macSize, ")"));

            case 17:
              mark = l - macSize;
              data = chunk.slice(0, mark);
              macd = chunk.slice(mark);
              _context2.next = 22;
              return _awaitAsyncGenerator(mac.digest(data));

            case 22:
              expected = _context2.sent;

              if (macd.equals(expected)) {
                _context2.next = 25;
                break;
              }

              throw new InvalidCryptoTransmissionError("MAC Invalid: ".concat(macd.toString('hex'), " != ").concat(expected.toString('hex')));

            case 25:
              _context2.next = 27;
              return _awaitAsyncGenerator(decipher.decrypt(data));

            case 27:
              decrypted = _context2.sent;
              _context2.next = 30;
              return decrypted;

            case 30:
              _iteratorNormalCompletion2 = true;
              _context2.next = 4;
              break;

            case 33:
              _context2.next = 39;
              break;

            case 35:
              _context2.prev = 35;
              _context2.t0 = _context2["catch"](2);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 39:
              _context2.prev = 39;
              _context2.prev = 40;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context2.next = 44;
                break;
              }

              _context2.next = 44;
              return _awaitAsyncGenerator(_iterator2.return());

            case 44:
              _context2.prev = 44;

              if (!_didIteratorError2) {
                _context2.next = 47;
                break;
              }

              throw _iteratorError2;

            case 47:
              return _context2.finish(44);

            case 48:
              return _context2.finish(39);

            case 49:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 35, 39, 49], [40,, 44, 48]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};